import { PinnedVersionSelectRowContent } from "./PinnedVersionSelectRowContent";
import type { PinnedVersionDropdownSections } from "./types";

import { SelectContent, SelectGroup, SelectItem, SelectLabel } from "@/components/ui/select";

export const PinnedVersionSelectContent = ({
  sections,
}: {
  sections: PinnedVersionDropdownSections;
}) => {
  const { latestRow, labelRows, versionRows } = sections;
  const hasLabels = labelRows.length > 0;
  const hasVersions = versionRows.length > 0;

  return (
    <SelectContent>
      <SelectGroup>
        <SelectItem value={latestRow.selectValue}>
          <PinnedVersionSelectRowContent row={latestRow} />
        </SelectItem>
      </SelectGroup>

      {hasLabels && (
        <SelectGroup>
          <SelectLabel className="px-2 pb-0.5 pt-2 text-[11px] font-medium text-muted-foreground/60">
            Labels
          </SelectLabel>
          {labelRows.map(row => (
            <SelectItem key={row.selectValue} value={row.selectValue}>
              <PinnedVersionSelectRowContent row={row} />
            </SelectItem>
          ))}
        </SelectGroup>
      )}

      {hasVersions && (
        <SelectGroup>
          <SelectLabel className="px-2 pb-0.5 pt-2 text-[11px] font-medium text-muted-foreground/60">
            Versions
          </SelectLabel>
          {versionRows.map(row => (
            <SelectItem key={row.selectValue} value={row.selectValue}>
              <PinnedVersionSelectRowContent row={row} />
            </SelectItem>
          ))}
        </SelectGroup>
      )}
    </SelectContent>
  );
};
